var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoadname(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 1.5V3.75M5.625 15.375H12.75H9.375V12M9.375 3.75H4.125L3 5.25L4.125 6.75H9.375M9.375 3.75V6M9.375 6.75V6M9.375 6.75V9M9.375 6H14.25L15.75 7.5L14.625 9H9.375M9.375 9H3.75L2.625 10.5L3.75 12H9.375M9.375 9V12",
    stroke: "#A3A9B9",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadname);
export default __webpack_public_path__ + "static/media/roadname.8b6a94f6ce881632d88b7b3bc7edcf29.svg";
export { ForwardRef as ReactComponent };